import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import ShareModal from './ShareModal'
import { ShareIcon, ButtonShare } from './ShareButtonStyledComponents'

class ShareButton extends React.PureComponent {
  constructor (props) {
    super(props)
    this.toggleShareModal = this.toggleShareModal.bind(this)
    this.state = {
      shareModalOpened: false
    }
  }

  toggleShareModal () {
    this.props.onToggle && this.props.onToggle(!this.state.shareModalOpened)
    this.setState({
      shareModalOpened: !this.state.shareModalOpened
    })
  }

  render () {
    const { shareModalOpened } = this.state
    const { vertical = false, children, activeStore } = this.props
    return (
      !activeStore.isPrivate() && (
        <>
          {children ? (
            React.cloneElement(children, { onClick: this.toggleShareModal })
          ) : (
            <ButtonShare onClick={this.toggleShareModal}>
              <ShareIcon /> <FormattedMessage id='store.actions.share.share' />
            </ButtonShare>
          )}
          {shareModalOpened &&
            <ShareModal
              {...this.props}
              isOpen={true}
              toggle={this.toggleShareModal}
              vertical={vertical}
            />
          }
        </>
      )
    )
  }
}

ShareButton.propTypes = {
  vertical: PropTypes.bool,
  onToggle: PropTypes.func,
  activeStore: PropTypes.object.isRequired,
  children: PropTypes.element
}

function mapStateToProps (state) {
  return {
    activeStore: state.activeStore
  }
}

export default connect(mapStateToProps)(injectIntl(ShareButton))
